import { useMemo } from "react";
import { decodeToken, getBasePath } from "../../../utils";
import { useAppSelector } from "src/redux/hooks/redux";
import { selectRole } from "src/redux/features/user/selectors/userState.selectors";

/**
 * Hook to manage Flow Hub authentication and navigation state.
 * Detects if the user is logged in based on the presence of a token
 * and determines the redirection path for the dashboard.
 */
export const useFlowHubAuth = () => {
  const userState = useAppSelector((state) => state.userState);
  const storedRoleType = useAppSelector(selectRole);

  // We check localStorage for the token as it is the primary source of
  // auth truth in the application's root (App.js).
  const token = sessionStorage.getItem("token");

  const { isLoggedIn, dashboardPath } = useMemo(() => {
    const userInfo = token ? decodeToken(token) : null;
    const roleType = storedRoleType ?? userInfo?.roles?.[0]?.type;
    const basePath = getBasePath(roleType);

    return {
      isLoggedIn: !!token,
      dashboardPath: basePath === "/" ? "/business" : basePath,
    };
  }, [token, storedRoleType]);

  const getUserName = (): string => {
    if (!token) return " Welcome, Guest!";
    return `Welcome back, ${userState?.firstName}!`;
  };

  const hasCompanies = useMemo(() => {
    return userState?.companies?.length > 0;
  }, [userState]);

  return {
    isLoggedIn,
    dashboardPath,
    token,
    getUserName,
    hasCompanies,
  };
};
